import * as styles from './styles.css';
import AvailabilityDay from './availability-day';
import { IAvailability, IComponent } from '../../interfaces';
import { useProps } from '../../hooks/use-props';

export interface IAvailabilityProps {
  id: string;
}

interface IAvailabilityError {
  monday?: string;
  tuesday?: string;
  wednesday?: string;
  thursday?: string;
  friday?: string;
  saturday?: string;
  sunday?: string;
}

interface IAvailabilityAtom extends IComponent {
  value: IAvailability;
  answer: IAvailability;
  error?: IAvailabilityError;
}

const initial_state = {
  monday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  tuesday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  wednesday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  thursday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  friday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  saturday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
  sunday: {
    morning: false,
    afternoon: false,
    evening: false,
  },
};

const useAvailability = (id: string) => {
  const { props, addAnswer } = useProps<IAvailabilityAtom>({ id, initial_state });
  return { props, setValue: (availability) => addAnswer({ availability }) };
};

const Availability = ({ id }: IAvailabilityProps) => {
  const {
    props: { value, show, error },
    setValue,
  } = useAvailability(id);
  if (!show) return null;
  return (
    <div id={id} className={styles.availability}>
      <div className={styles.label}>
        <b>What’s your general availability?</b>{' '}
        <span style={{ fontWeight: 400 }}>&nbsp;(Select all that apply.)</span>
      </div>
      <div className={styles.days_spacing}>
        <AvailabilityDay
          id={`${id}-monday`}
          day={'Monday'}
          state={value.monday}
          error={error?.monday}
          setState={(monday) => setValue({ ...value, monday })}
        />
        <AvailabilityDay
          id={`${id}-tuesday`}
          day={'Tuesday'}
          state={value.tuesday}
          error={error?.tuesday}
          setState={(tuesday) => setValue({ ...value, tuesday })}
        />
        <AvailabilityDay
          id={`${id}-wednesday`}
          day={'Wednesday'}
          state={value.wednesday}
          error={error?.wednesday}
          setState={(wednesday) => setValue({ ...value, wednesday })}
        />
        <AvailabilityDay
          id={`${id}-thursday`}
          day={'Thursday'}
          state={value.thursday}
          error={error?.thursday}
          setState={(thursday) => setValue({ ...value, thursday })}
        />
        <AvailabilityDay
          id={`${id}-friday`}
          day={'Friday'}
          state={value.friday}
          error={error?.friday}
          setState={(friday) => setValue({ ...value, friday })}
        />
        <AvailabilityDay
          id={`${id}-saturday`}
          day={'Saturday'}
          state={value.saturday}
          error={error?.saturday}
          setState={(saturday) => setValue({ ...value, saturday })}
        />
        <AvailabilityDay
          id={`${id}-sunday`}
          day={'Sunday'}
          state={value.sunday}
          error={error?.sunday}
          setState={(sunday) => setValue({ ...value, sunday })}
        />
      </div>
    </div>
  );
};

export default Availability;
